import { render } from "./SessionActivityItem.vue?vue&type=template&id=47f86a5a&scoped=true"
import script from "./SessionActivityItem.vue?vue&type=script&lang=js"
export * from "./SessionActivityItem.vue?vue&type=script&lang=js"

import "./SessionActivityItem.vue?vue&type=style&index=0&id=47f86a5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f86a5a"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QList from 'quasar/src/components/item/QList.js';import Ripple from 'quasar/src/directives/Ripple.js';
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QItemSection,QAvatar,QBadge,QSpinnerDots,QIcon,QTooltip,QItemLabel,QBtn,QMenu,QItem,QList});qInstall(script, 'directives', {Ripple,ClosePopup});
